export default __webpack_public_path__ + "static/media/socashless-logo-no-text.d322bf7f.svg";